module.exports = __webpack_public_path__ + "img/k04.31ee6ec9.png";